<template>
  <div class="container">
    <div style="text-align: center;width: 100%;height: 1200px;">
      <div style="height: 230px"></div>
      <div style="width: 700px;margin:0 auto;border-radius:5px;background-color: rgba(30,30,30,0.5);color:#fff"><br>
        <h2>特检智慧平台</h2>
        帐　号：<el-input ref="username" size="small" v-model="loginForm.userAccount" @keydown.enter.native="login()" style="width: 300px;" placeholder="登录帐号"></el-input>
        <br><br><br>密　码：<el-input ref="userpwd" type="password" size="small" v-model="loginForm.userPassword" @keydown.enter.native="login()" style="width: 300px;" placeholder="登录密码"></el-input>
        <br><br><br><el-button type="primary" size="small" :disabled="loginState" @click="login()" style="width: 343px" v-html="loginText"></el-button>
        <br><br><br><br>
      </div>
    </div>
  </div>
</template>

<script>
import { appjs } from '@/utiljs/apputil'
export default {
  data () {
    return {
      loginForm: {
        userAccount: '',
        userPassword: ''
      },
      loginState: false,
      loginText: '登录'
    };
  },
  created () {
    if (localStorage.getItem("clientId") == null || localStorage.getItem("clientId") == "") {
      localStorage.setItem("clientId", appjs.getUuid());
    }
  },
  mounted () {
    this.$refs.username.focus();
  },
  methods: {
    login () {
      if (this.loginForm.userAccount == "") {
        this.$refs.username.focus();
        appjs.showWarningMsg('输入帐号')
        return;
      }
      if (this.loginForm.userPassword == "") {
        this.$refs.userpwd.focus();
        appjs.showWarningMsg('请输入密码')
        return;
      }
      let params = {
        clientId: localStorage.getItem("clientId"),
        userAccount: this.loginForm.userAccount,
        userPassword: this.loginForm.userPassword
      }
      this.loginState = true;
      this.loginText = '登录中....'
      let _self = this;
      appjs.requestWithNoToten('userLogin', params).then((data) => {
        if (data.retCode && data.retCode != 'ok') {
          appjs.showErrorMsg(data.retMsg);
          _self.loginText = '登录';
          _self.loginState = false;
        } else {
          _self.loginText = '登录';
          _self.loginState = false;
          let userInfo = {
            userName: data.additionalData.loginUserName,
            userAccount: data.additionalData.loginUserAccount,
            userPkid: data.additionalData.loginUserPkid,
            loginTenantName: data.additionalData.loginTenantName,
            authorization: data.additionalData.authorization
          }
          _self.$store.commit('setLoginUser', userInfo)
          _self.$router.push('/main');
        }
      }).catch((error) => {
        _self.loginText = '登录';
        _self.loginState = false;
        appjs.showErrorMsg("服务器异常：" + error)
      })
    }
  }
};
</script>
<style>
.container {
  height: 100vh;
  background-image: url('~@/assets/images/main.png');
  background-size: 100% 100%;
  overflow: hidden;
  text-align: center;
}
.login-box {
  margin: 0px auto 0px;
  background: #fff;
  border-radius: 10px;
  width: 410px;
  height: 325px;
}
</style>
